import axios from 'axios'
import {
  localToken
} from '@/libs/util';
import globConfig from '@/config/config';
import {
  Message
} from 'element-ui'
class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl;
    this.queue = {}
  }

  getInsideConfig() {
    return {
      baseURL: this.baseUrl,
      headers: {}
    };
  }

  distroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {}
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      let tenant_id = localToken.getTenant()
      if (tenant_id && tenant_id != 'undefined') {
        config.headers.tntId = tenant_id
      }
      else {
        // Toast('请在登陆链接中添加Tenant_Id参数刷新并重新登录');
        Message({
          message: '请在登陆链接中添加商户参数刷新并重新登录',
          type: 'warning'
        });
        return
      }
      this.queue[url] = true;

      //是否无需access_token 的方法 start
      let whiteMethod = false;
      let whiteMethodList = globConfig.apiWhite || [];
      for (let i = 0; i < whiteMethodList.length; i++) {
        if (url.indexOf(whiteMethodList[i]) > -1) {
          whiteMethod = true;
          break;
        }
      }
      console.log('whiteMethod', whiteMethod);
      if (whiteMethod) { //白名单方法 无需token
        config.headers.Authorization = "";
        // config.headers.tntId = "achina"
      } else {

        //获取本地存放的token
        let access_token = localToken.getToken();
        if (!access_token) { //token有问题
          localToken.clearLocal();
          setTimeout(() => {
            window.location.reload()
          }, 500)
          return Promise.reject('登录状态无效，请重新登录')
          // return;
        }
        config.headers.Authorization = access_token;
      }

      return config
    }, error => {
      return Promise.reject(error)
    });

    // 响应拦截
    instance.interceptors.response.use(res => {
      console.log(res, '响应数据');
      this.distroy(url);
      let data = res.data;
        if (url.indexOf('Login') > -1) {
        if (typeof res.status !== 'undefined' && res.status === 200 && res.data.resultCode == 0 && typeof res.data.entity.accessToken !== 'undefined' && res.data.entity.accessToken !== null) {
          let token = "Bearer " + res.data.entity.accessToken || ""; //token值
          let expires = res.data.entity.expiredTime || 7200;
          localToken.setToken(token, expires); //存储token（已经登录的token）
          localToken.setUser(res.data.entity.tenantName || "");
          localToken.setWorkShopName(res.data.entity.workShopName || "");
          // 记住登录密码
          if(JSON.parse(res.config.data).isRemember){
            localToken.setRememberInfo(res.config.data);
          }else{
            localToken.setRememberInfo("");
          }
        } else {
          Message({
            showClose: true,
            duration: 800,
            message: data.resultMsg,
            type: "error"
          });
        }
        return data
      } else if (res.status === 200) {
        if (res.data.resultCode == 0) {
          return res.data.entity || []
        } else {
          Message({
            showClose: true,
            duration: 800,
            message: res.data.resultMsg,
            type: "error"
          });
          return null
        }
      } else {
        console.log('来这里了');
        return Promise.reject(data);
      }
    }, error => {
      this.distroy(url);
      return Promise.reject(error)
    })
  }

  //通用请求
  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options.url);
    return instance(options)
  }

  //增加几种常用方式
  get(options) {
    options = Object.assign({
      method: 'get'
    }, options);
    return this.request(options);
  }

  post(options) {
    options = Object.assign({
      method: 'post'
    }, options);
    return this.request(options);
  }

  put(options) {
    options = Object.assign({
      method: 'put'
    }, options);
    return this.request(options);
  }

  del(options) {
    options = Object.assign({
      method: 'delete'
    }, options);
    return this.request(options);
  }

  path(options) {
    options = Object.assign({
      method: 'path'
    }, options);
    return this.request(options);
  }

  parseParams(data) {
    try {
      let tempArr = [];
      for (let i in data) {
        let key = encodeURIComponent(i);
        let value = encodeURIComponent(data[i]);
        tempArr.push(key + '=' + value);
      }
      return tempArr.join('&');

    } catch (err) {
      return '';
    }
  }

}

export default HttpRequest



// WEBPACK FOOTER //
// ./src/libs/api.axios.js